import React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useTranslation } from "react-i18next";

import { containerS } from "../../../styles/containerStyles";
import Comment from "./Comment";
export interface OrderHistoryProps { }

// OrderStatusType enum names (API statusName) -> keys in orders.statuses
const statusKeys: { [statusName: string]: string } = {
  Placed: "placed",
  Accepted: "accepted",
  DuringRealization: "inProgress",
  Realized: "completed",
  Cancelled: "canceled",
  Invoiced: "invoiced",
};

const UNKNOWN_USER_FIRST_NAME = "Nieznany";
const UNKNOWN_USER_LAST_NAME = "Użytkownik";



const OrderHistory: React.FC<OrderHistoryProps> = () => {
  const { t } = useTranslation("admin");
  const { orderHistory } = useSelector((state: RootStateOrAny) => state.orderPanel)
  return (
    <div className={containerS}>
      {orderHistory && orderHistory.map((item: any) => {
        const statusKey = statusKeys[item.statusName];
        const statusLabel = statusKey
          ? t("orders.history.statuses." + statusKey, { defaultValue: item.statusDescription })
          : item.statusDescription;
        // The API returns a placeholder user ("Nieznany Użytkownik") when the author is unknown
        const isUnknownUser = !item.user ||
          (item.user.firstName === UNKNOWN_USER_FIRST_NAME && item.user.lastName === UNKNOWN_USER_LAST_NAME);
        return (
          <Comment
            key={item.date}
            content={statusLabel}
            id={item.date}
            user={isUnknownUser ? { firstName: t("orders.history.unknownFirstName"), lastName: t("orders.history.unknownLastName") } : item.user}
            createdAt={item.date.split("").splice(0, 10).join("") + " " + item.date.split("T")
              .splice(1, 1)
              .join("")
              .split(".")
              .splice(0, 1)
              .join("")}
          />
        );
      })}
    </div>
  );
};

export default OrderHistory;
